import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Cache } from 'aws-amplify';
import { PROGRAMA_FINANCIAR } from '../../../constants/form/validations';
import { DIALOG } from '../../../constants/dialog/dialog';
import { useDialog } from '../../../context/dialog-context';
import ConstantesSolicitudService from '../../../services/shared/constantes-solicitud-service';
import FormInput from '../../../components/Input/FormInput';
import useInput from '../../../hooks/use-input';
// import { useAuth } from '../../../context/auth-context';
import ComponenteConBotones from '../../../components/DynamicForm/ButtonLine';
import { BINARIO } from '../../../constants/form/request-form';
// import OpenCoopCrmService from '../../../services/verification/open-coop-service';

const ProgramaFinanciar = ({
  formConstants,
  onSeleccionChange,
  showMessage,
  fetchedConsultDataOpen,
  creditRenovationInfo
}) => {
  // const { user } = useAuth();
  const isMounted = useRef(false);
  const [jornadas, setJornadas] = useState();
  const [periodos, setPeriodos] = useState();
  const [tipoPeriodo, setTipoPeriodo] = useState();
  // const [fetchedConsultDataOpen, setFetchedConsultDataOpen] = useState();
  const handleSeleccionChange = (nuevaSeleccion) => {
    onSeleccionChange(nuevaSeleccion);
  };
  // Array to handle the state of PRO line temporarily
  const estadoPro = ['abierto', 'limitado', 'cerrado'];
  const idStatusPro = 0;
  const dialog = useDialog();
  const {
    register,
    getValues,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useFormContext();

  const watchUniversidad = watch('universidad');
  const watchPrograma = watch('programa');
  const watchNivel = watch('nivel');
  const watchLinea = watch('linea');
  const watchPeriodo = watch('periodo_cursa');
  const watchTransferencia = watch('transferencia');
  const isOtroPrograma = watchPrograma?.toString() === 'otro';
  const isTechNivel = watchNivel?.toString() === '8';
  const showPeriodos = tipoPeriodo?.toString() !== 'Hora';
  const programas = Cache.getItem(
    `PROGRAMAS_${watchUniversidad}_${watchNivel}`
  );

  // esto es temporar ya que necesitamos solo subir los simuladores :D
  const universidadSinUTB = [];
  formConstants.UNIVERSIDAD.forEach((element) => {
    if (
        element.value === 1 || 
        element.value === 2 || 
        element.value === 3 || 
        element.value === 5 || 
        element.value === 6 || 
        element.value === 7 || 
        element.value === 8 || 
        element.value === 9 ||
        element.value === 10 ||
        element.value === 11 ||
        element.value === 12 ||
        element.value === 13 ||
        element.value === 14
      ) {
      universidadSinUTB.push(element);
    }
  });
  let nivelAcademico = [];
  if (Number(watchUniversidad) === 1 || Number(watchUniversidad) === 3) {
    formConstants.NIVEL_ACADEMICO.forEach((element) => {
      if (
        element.value === 2 ||
        element.value === 3 ||
        element.value === 4 ||
        element.value === 7
      ) {
        nivelAcademico.push(element);
      }
    });
  } else if (Number(watchUniversidad) === 2) {
    formConstants.NIVEL_ACADEMICO.forEach((element) => {
      if (element.value !== 5) {
        nivelAcademico.push(element);
      }
    });
  } else {
    formConstants.NIVEL_ACADEMICO.forEach((element) => {
      if (element.value !== 5 && element.value !== 8) {
        nivelAcademico.push(element);
      }
    });
    // nivelAcademico = formConstants.NIVEL_ACADEMICO;
  }
  const watchTieneFinanciacion = watch('tiene_financiacion');
  const { InputProps, setLoading } = useInput({
    errors,
    getValues,
    register,
    control,
    validations: PROGRAMA_FINANCIAR,
  });
  const lineasArray = useMemo(() => {
    const tipoEstudiante = fetchedConsultDataOpen ? 'RE' : 'nuevo';
    let options = [];
    if (Number(watchUniversidad) === 4) {
      options = [
        {
          value: '6',
          label: 'Línea Tech',
          url: 'https://www.youtube.com/embed/7WYOhHXfEAU',
        },
      ];
    } else if(Number(watchUniversidad) === 13) {
      options = [
        {
          value: '17',
          label: 'Línea Estrella Virtual',
          url: 'https://www.youtube.com/embed/DgSXdHwrEz8',
        },
      ];

    }
     else if(Number(watchUniversidad) === 14) {
      options = [
        {
          value: '17',
          label: 'Línea Estrella Cero',
          url: 'https://www.youtube.com/embed/GaQpo6MXY24',
        },
      ];

    } else {
      options = [
        {
          value: '1',
          label: 'Línea Estrella',
          url: 'https://www.youtube.com/embed/AvY3gNcU9Y0',
        },
      ];
    }
    // check nivel pregrado
    if (watchNivel?.toString() !== '1' ) {
      // check estado PRO is not closed
      // // if (estadoPro[idStatusPro] !== 'cerrado') {
        // check universidad externado
        if (watchUniversidad?.toString() === '2') {
          // check if estado PRO is limited
          // if (estadoPro[idStatusPro] === 'limitado') {
          // }
        if (watchPeriodo > 1 && tipoEstudiante === 'RE' && watchNivel?.toString() === '4'  && creditRenovationInfo.linea.id.toString() !== '9') {
            options.push({
              value: '2',
              label: 'Línea PRO',
              url: 'https://www.youtube.com/embed/5Ncm1ZkMI7o',
            });
          }else if (estadoPro[idStatusPro] === 'abierto' && tipoEstudiante === 'RE' && watchNivel?.toString() === '4' && creditRenovationInfo.linea.id.toString() !== '9') {
            options.push({
              value: '2',
              label: 'Línea PRO',
              url: 'https://www.youtube.com/embed/5Ncm1ZkMI7o',
            });
          } else if (tipoEstudiante === 'nuevo' && Number(watchNivel) !== 8) {
            options.push({
              value:'9',
              label: 'Línea Andina',
              url: 'https://www.youtube.com/embed/vtdjVtF2xfA'
            });
          } else if ( tipoEstudiante === 'RE' && creditRenovationInfo?.lineaAnterior?.nombre === 'Línea Andina') {
            options.push({
              value:'9',
              label: 'Línea Andina',
              url: 'https://www.youtube.com/embed/vtdjVtF2xfA'
            });
          } else if ( Number(watchNivel) !== 1 && Number(watchNivel) !== 8) {
            options.push({
              value:'9',
              label: 'Línea Andina',
              url: 'https://www.youtube.com/embed/vtdjVtF2xfA'
            });
          }
        }
      // // }
      // check universidad usb
      if (
        watchUniversidad?.toString() === '1'
        // && watchTieneFinanciacion?.toString() === 'false'
      ) {
        // options.push({value: '3', label: 'Tasa CERO', url: 'https://www.youtube.com/embed/cfUrgjRXEtQ'});
        // if(Number(watchPrograma)  === 5 || Number(watchPrograma)  === 2 || Number(watchPrograma)  === 67){
        //     options.push({value: '7', label: 'Línea Pacífico', url: 'https://www.youtube.com/embed/R7-5LuyID2M'});
        // }
        options.push({
          value: '7',
          label: 'Línea Pacífico',
          url: 'https://www.youtube.com/embed/zZY3f319KLk',
        });
      }
    }
    if (
      watchUniversidad?.toString() === '1' 
    ) {
      if (
        Number(watchNivel) === 7 && Number(watchPrograma) === 484
      ) {
        options[0].url = 'https://www.youtube.com/embed/MNU8WArZojE';
      } else {
        options.push({
          value: '8',
          label: 'Línea Sultana',
          url: 'https://www.youtube.com/embed/MNU8WArZojE',
        });
      }
      options[0].url = 'https://www.youtube.com/embed/uKcCDc4U4xM';
    }
    
    // check universidad utb
    if (watchUniversidad?.toString() === '3') {
      if (Number(watchNivel) === 4) {
        options.push({
          value: '5',
          label: 'Línea Heroica',
          url: 'https://www.youtube.com/embed/fhtmKKbOiRE',
        });
      }
      options.push({
        value: '4',
        label: 'Línea Caribe',
        url: 'https://www.youtube.com/embed/7eOAjFebIUw',
      });
      options[0].url = 'https://www.youtube.com/embed/N3F9ZoY0XAE';
    }

    // check universidad CUC
    if (watchUniversidad?.toString() === '5') {
      if (Number(watchNivel) === 4) {
        options.push({
          value: '13',
          label: 'Línea Curramba',
          url: 'https://www.youtube.com/embed/uif3yX44hPU',
        });
      }
      options[0].url = 'https://www.youtube.com/embed/CDyyJGzcxg8';
    }

// check universidad UPB
if (watchUniversidad?.toString() === '6') {
  if (Number(watchNivel) === 4) {
      options.push({
        value:'12',
        label: 'Línea Chicamocha',
        url: 'https://www.youtube.com/embed/6CzianiZh34'
      });
      options.push({
        value: '10',
        label: 'Línea Barichara',
        url: 'https://www.youtube.com/embed/swf8hoPizv4?si=8N7oXIS3oAMQioMl',
      });
      options.push({
        value: '16',
        label: 'Línea Boreal',
        url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
      });
      options[0].url = 'https://www.youtube.com/embed/V_EvCITe0EA';
    }
    else if (watchNivel === '9') {
        options.push({
          value: '11',
          label: 'Línea Barichara Tec',
          url: 'https://www.youtube.com/embed/pB9rg8OY-Q0',
        });
        options.splice(0, 1);
    }
  else {
    options.push({
      value: '10',
      label: 'Línea Barichara',
      url: 'https://www.youtube.com/embed/swf8hoPizv4?si=8N7oXIS3oAMQioMl',
    });
    options.push({
      value: '16',
      label: 'Línea Boreal',
      url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
    });
    options[0].url = 'https://www.youtube.com/embed/V_EvCITe0EA';
  }
} 

    if (watchUniversidad?.toString() === '7') {
      if (Number(watchNivel) === 4) {
        options.push({
          value:'14',
          label: 'Línea Nova',
          url: 'https://www.youtube.com/embed/YRPt-WpVs4E'
        });
        options.push({
          value: '16',
          label: 'Línea Boreal',
          url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
        });
        options[0].url = 'https://www.youtube.com/embed/DMiXeqqIfhE';
      } 
      else {
        options.push({
        value: '16',
        label: 'Línea Boreal',
        url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
      });
        options[0].url = 'https://www.youtube.com/embed/DMiXeqqIfhE';
      }
    }

    if (watchUniversidad?.toString() === '8') {
      if (Number(watchNivel) === 4) {
        options.push({
          value:'14',
          label: 'Línea Nova',
          url: 'https://www.youtube.com/embed/IE-CcdD_A_s'
        });
        options.push({
          value: '16',
          label: 'Línea Boreal',
          url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
        });
        options[0].url = 'https://www.youtube.com/embed/StOo_5xECdc';
      } 
      else {
        options.push({
          value: '16',
          label: 'Línea Boreal',
          url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
        });
        options[0].url = 'https://www.youtube.com/embed/StOo_5xECdc';
      }
    }

    if (watchUniversidad?.toString() === '9') {
      if (Number(watchNivel) === 4) {
        options.push({
          value:'14',
          label: 'Línea Nova',
          url: 'https://www.youtube.com/embed/EmkyLeVSUas'
        });
        options.push({
          value: '16',
          label: 'Línea Boreal',
          url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
        });
        options[0].url = 'https://www.youtube.com/embed/TNW_iqQ4BKU';
      } 
      else {
        options.push({
          value: '16',
          label: 'Línea Boreal',
          url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
        });
        options[0].url = 'https://www.youtube.com/embed/TNW_iqQ4BKU';
      }
    }

    if (watchUniversidad?.toString() === '10') {
      if (Number(watchNivel) === 4) {
        options.push({
          value:'14',
          label: 'Línea Nova',
          url: 'https://www.youtube.com/embed/ScOAQZw6u50'
        });
        if(watchTransferencia?.toString() === 'true') {
          options.push({
            value: '16',
            label: 'Línea Boreal',
            url: 'https://www.youtube.com/embed/NJ7OSPueeMs',
          });
        }
        options[0].url = 'https://www.youtube.com/embed/Hv9yJDNwJsk';
      } 
      else {
        options[0].url = 'https://www.youtube.com/embed/Hv9yJDNwJsk';
      }
    }

    if (watchUniversidad?.toString() === '11') {
      if (Number(watchNivel) === 4) {
        options.push({
          value:'14',
          label: 'Línea Nova',
          url: 'https://www.youtube.com/embed/s6cokSVVJa8'
        });
        if(watchTransferencia?.toString() === 'true') {
          options.push({
            value: '16',
            label: 'Línea Boreal',
            url: 'https://www.youtube.com/embed/YzWeZCHOEag',
          });
        }
        options[0].url = 'https://www.youtube.com/embed/NTwYAmzBROE';
      } 
      else {
        options[0].url = 'https://www.youtube.com/embed/NTwYAmzBROE';
      }
    }

    if (watchUniversidad?.toString() === '12') {
      if (Number(watchNivel) === 4) {
        options.push({
          value:'14',
          label: 'Línea Nova',
          url: 'https://www.youtube.com/embed/v2GUVGtf8MI'
        });
        if(watchTransferencia?.toString() === 'true') {
          options.push({
            value: '16',
            label: 'Línea Boreal',
            url: 'https://www.youtube.com/embed/IKlKllLxYHM',
          });
        }
        options[0].url = 'https://www.youtube.com/embed/LtpDVJdI_tA';
      } 
      else {
        options[0].url = 'https://www.youtube.com/embed/LtpDVJdI_tA';
      }
    }

    if (watchUniversidad?.toString() === '13') {
      if (Number(watchNivel) === 4) {
        options.push({
          value: '14',
          label: 'Línea Nova Virtual',
          url: 'https://www.youtube.com/embed/gDaYFcegtIg'
        });
      }if (watchTransferencia?.toString() === 'true') {
        options.push({
          value: '16',
          label: 'Línea Boreal Virtual',
          url: 'https://www.youtube.com/embed/QBqXMMq2OPc'
        });
      }
    }
    if (watchUniversidad?.toString() === '14') {
      options.push({
        value:'18',
        label: 'Línea Estrella Plus',
        url: 'https://www.youtube.com/embed/xSOk-3nnPVw'
      });
    }

    const updateLinea = [];
    for (const li of options) {
      const optionLinea = li.label.replace(/Línea/g, '');
      updateLinea.push({
        id: li.value,
        title: li.label,
        hide: false,
        src: li.url,
        option: optionLinea.replace(/\s/g, ''),
      });
    }

    return updateLinea;
  }, [
    watchUniversidad,
    watchNivel,
    watchTieneFinanciacion,
    watchPeriodo,
    watchPrograma,
    watchTransferencia,
  ]);

  let programaNotOther = programas;
  if (Number(watchNivel) !== 1) {
    const valuesToRemove = [];

    if (programas) {
      const filteredOptions = programas.filter(
        (option) => !valuesToRemove.includes(option.value)
      );
      programaNotOther = filteredOptions;
    }
  }

  /* tenemos que conectar a un servicio */
  const fetchProgramas = async () => {
    if (watchUniversidad && watchNivel && programas === null) {
      setLoading('programa', true);
      await ConstantesSolicitudService.getProgramasByNivelAcademico(
        watchUniversidad,
        watchNivel
      )
        .then((response) =>
          Cache.setItem(
            `PROGRAMAS_${watchUniversidad}_${watchNivel}`,
            response
            // Number(watchNivel) === 1 && response
            //   ? response.concat([
            //       {
            //         value: 'otro',
            //         label: 'Otro',
            //       },
            //     ])
            //   : response
          )
        )
        .catch((error) => {
          console.error(error);
          dialog.info(DIALOG.N11, {
            devInfo: error.message || error.code || error.type,
          });
        });
      setLoading('programa', false);
      setValue('programa', getValues('programa'));
    }
  };

  useEffect(() => {
    fetchProgramas();
  }, [watchUniversidad, watchNivel]);

  // useEffect(() => {
  //   const fetchOpenCoopData = async () => {
  //     const body = {
  //       nro_identificacion: user['custom:document'],
  //       rol: 'consultaOpenCreditosServicio',
  //     };
  //     const resul = await OpenCoopCrmService.postOpenCoop(body);
  //     let consultDataOpenResult = resul === null ? [] : resul?.listCustomer;
    
  //     let consultDataOpen = [];
  //         if (Array.isArray(consultDataOpenResult)) {
  //           consultDataOpen = consultDataOpenResult.map(
  //             subArray => 
  //             subArray.sort((a, b) => new Date(b.fecha_apertura) - new Date(a.fecha_apertura))
  //           );
    
  //           if (consultDataOpen.length > 0 ) {
  //             consultDataOpenResult = consultDataOpen.length === 0 ? null : consultDataOpen[0][0];
  //             // setFetchedConsultDataOpen(consultDataOpenResult);
  //           }
  //         }
  //   };
  //   fetchOpenCoopData();
  // }, [user, fetchedConsultDataOpen]);



  const fetchPeriodoAndJornada = async () => {
    setPeriodos();
    setJornadas();
    setTipoPeriodo();
    if (watchPrograma && !isOtroPrograma) {
      setLoading('periodo_cursa', true);
      setLoading('jornada', true);
      await Promise.all([
        ConstantesSolicitudService.getPrograma(
          Number(watchPrograma) === 0 ? 1 : watchPrograma
        )
          .then((response) => {
            setTipoPeriodo(response.tipoPeriodo);
            const periodos = [];
            for (let i = 0; i < response.numeroPeriodos; i++)
              periodos.push({
                value: i + 1,
                label: i + 1,
              });
            setPeriodos(periodos);
          })
          .catch((error) => {
            console.error(error);
            dialog.info(DIALOG.N11, {
              devInfo: error.message || error.code || error.type,
            });
          }),
        ConstantesSolicitudService.getJornadasByPrograma(watchPrograma)
          .then((response) => {
            setJornadas(response);
          })
          .catch((error) => {
            console.error(error);
            dialog.info(DIALOG.N11, {
              devInfo: error.message || error.code || error.type,
            });
          }),
      ]);
    }
  };

  useEffect(() => {
    fetchPeriodoAndJornada();
  }, [watchPrograma]);

  useEffect(() => {
    if (periodos) {
      setValue('periodo_cursa', getValues('periodo_cursa'));
      setLoading('periodo_cursa', false);
    }
  }, [periodos]);

  useEffect(() => {
    if (jornadas) {
      setValue('jornada', getValues('jornada'));
      setLoading('jornada', false);
    }
  }, [jornadas]);

  useEffect(() => {
    isMounted.current = true;
    return () => (isMounted.current = false);
  }, []);

  const taxCategory = useMemo(() => {
    if( watchUniversidad?.toString() === '2' && tipoPeriodo === 'Trimestre' && watchNivel?.toString() !== '4') {
      return 'estrella_trimestre';
    }

    if (tipoPeriodo) {
      if (watchLinea === '2') {
        if (tipoPeriodo === 'Año') return 'pro_annual';
        return 'pro';
      } else if (watchLinea === '3') {
        return 'zero';
      } else if (watchLinea === '4') {
        return 'caribe';
      } else if (watchLinea === '5') {
        return 'heroica';
      } else if (watchLinea === '6') {
        return 'tech';
      } else if (watchLinea === '7') {
        return 'pacifico';
      } else if (watchLinea === '8') {
        return 'sultana';
      } else if (watchLinea === '9') {
        if (tipoPeriodo === 'Año') return 'andina_annual';
        return 'andina';
      } else if (watchLinea === '10') {
        return 'barichara';
      } else if (watchLinea === '11') {
        return 'barichara_tec';
      } else if (watchLinea === '12') {
        return 'chicamocha';
      } else if (watchLinea === '13') {
        return 'curramba';
      } else if (watchLinea === '14') {
        return 'nova';
      } else if (watchLinea === '15') {
        return 'orion';
      } else if (watchLinea === '16') {
        return 'boreal';
      } else if (watchLinea === '17') {
        return 'estrella_cero';
      } else if (watchLinea === '18') {
        return 'estrella_plus';
      } else if (tipoPeriodo === 'Año') {
        return 'annual';
      } else return 'estrella';
    }

  }, [watchLinea, tipoPeriodo]);

  useEffect(() => {
    setValue('tax_category', taxCategory);
  }, [taxCategory]);

  useEffect(() => {
    const selectElement = document.getElementById('universidadSelect');
    if (selectElement) {
      selectElement.value = '0';
    }
  }, []);

  return (
    <>
      <section>
        <h4 className="font-bold">
          Información del programa o carrera que te apasiona
        </h4>
        <div className="my-4 grid grid-cols-1 gap-4 gap-y-6 lg:my-6 lg:grid-cols-1 lg:gap-6">
          <div className="col-span-2 grid grid-cols-2 gap-4 gap-y-6 lg:gap-6">
            <FormInput
              {...InputProps('universidad')}
              placeholder="Universidad"
              type="select"
              options={universidadSinUTB}
              id={'universidadSelect'}
            />
            <FormInput
              {...InputProps('nivel')}
              placeholder="Nivel académico"
              type="select"
              options={nivelAcademico || formConstants.NIVEL_ACADEMICO}
            />
            {!isTechNivel && (
              <>
                <FormInput
                  {...InputProps('programa')}
                  placeholder="Programa"
                  type="select"
                  options={programaNotOther || []}
                  className="col-span-2"
                />
                {!isOtroPrograma && (
                  <>
                    <FormInput
                      {...InputProps('jornada')}
                      placeholder="Jornada"
                      type="select"
                      options={jornadas}
                    />
                    {showPeriodos && (
                      <FormInput
                        {...InputProps('periodo_cursa')}
                        placeholder={(tipoPeriodo || 'Periodo') + ' a cursar'}
                        type="select"
                        options={periodos}
                      />
                    )}
                  </>
                )}
                {['10', '11', '12', '13'].includes(watchUniversidad?.toString()) && watchNivel?.toString() === '4' &&
                  <>
                    <FormInput
                      {...InputProps('transferencia')}
                      placeholder="Transferencia"
                      type="select"
                      options={BINARIO}
                    />
                  </>
                }
              </>
            )}
          </div>
        </div>
        <h4 className="font-bold">
          Conoce y elige la línea de financiación para ti
        </h4>
        <ComponenteConBotones
          universidadId={watchUniversidad?.toString()}
          lineas={lineasArray}
          onSeleccionChange={handleSeleccionChange}
        />
        {showMessage && (
          <>
            <p className="text-center disabled">
              Estamos conectando con tu Universidad, esto podría tomar algunos
              segundos...
            </p>
            <br />
          </>
        )}
      </section>
    </>
  );
};

export default ProgramaFinanciar;